import nl from './lang/nl';

export default { nl };



// WEBPACK FOOTER //
// ./src/app/config/i18n.js